export default "__VITE_ASSET__cf729685__"